<template>
  <div :tabindex="should_show_tooltip ? 0 : null" ref="monthEl" class="month" @focus="initTooltip" @mouseenter="initTooltip" @mouseleave="teardownTooltip">
    <div class="count-container">
      <div v-for="(count, sample) in linkingCounts" :key="sample" class="count-item">
        <span class="count-label">n<sub>{{sample}}</sub></span> = <span class="count">{{count}}</span>
      </div>
    </div>
    <month-topics :year="year" :month="month" />
  </div>
</template>

<script setup>
import MonthTopics from "./MonthTopics.vue";
import {computed, inject, provide, toRef, useTemplateRef} from "vue";
import { makeTooltipData } from "../lib/helpers";
import {useMonthTooltip} from "../composables/useMonthTooltip";

const props = defineProps({
  year: Number,
  // 0-based month
  month: Number
});

const tooltips_enabled = inject("tooltips_enabled");
const tooltip_data = inject("tooltip_data");
const getLinkingCounts = inject("getLinkingCounts");
const getSelectedSampleTopics =  inject("getSelectedSampleTopics")
const monthEl = useTemplateRef('monthEl');
const yearRef = toRef(props, "year");
const monthRef = toRef(props, "month");

const selectedSampleTopics =  getSelectedSampleTopics(props.year, props.month);
provide('selectedSampleTopics', selectedSampleTopics);

const linkingCounts = computed(() => getLinkingCounts(props.year, props.month));

const {
  should_show_tooltip,
  initTooltip,
  teardownTooltip
} = useMonthTooltip({
  year: yearRef,
  month: monthRef,
  monthEl,
  tooltips_enabled,
  tooltip_data,
  makeTooltipData,
  getLinkingCounts,
  getSelectedSampleTopics
});

</script>

<style scoped>
.month {
  min-height: 105px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 105px;
  width: 100%;
  &:hover {
    background: #e4e4e4;
  }
}

.count-item {
  text-wrap: nowrap;
  overflow: clip;
}

.count-label {
  font-weight: bold;
  font-style: italic;
  font-size: 80%;
}
</style>
